'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('dynamic-page-list', {
      url: '/admin/dynpage/list',
      template: '<dynamic-page-list></dynamic-page-list>',
      authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/dynamic-pages/list/dynamic-page-list.routes.js